var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"footer-area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('div',{staticClass:"copyright-area"},[_c('p',[_vm._v("© "+_vm._s(new Date().getFullYear())+" ManuEl Magak")])])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }